import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';

import { FaqsService } from '../faqs-service/faqs.service';
import { Injectable } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { QuestionList } from 'src/app/shared/models/questionList';
import { ShellService } from 'src/app/shell/shell.service';

@Injectable({
  providedIn: 'root',
})
export class QuestionListResolver implements Resolve<QuestionList> {
  constructor(
    private faqsService: FaqsService,
    private shellService: ShellService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<QuestionList> {
    this.shellService.setIsLoading(true);

    const name = route.params['name'];
    const parentName = route.params['parentName'];
    const previusName = route.params['previusName'];

    return this.faqsService
      .getQuestionListByName(previusName, parentName, name)
      .pipe(finalize(() => this.shellService.setIsLoading(false)));
  }
}
